(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["international-store-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-international-store-modal]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const storageKey = 'stars-international-store-choice';
    const storageDays = 30;
    const now = Date.now();
    const forcePreview = new URLSearchParams(window.location.search).get('show_international_modal') === '1';

    const getStoredChoice = () => {
      try {
        const stored = JSON.parse(localStorage.getItem(storageKey));
        if (!stored || stored.expiresAt <= now) {
          localStorage.removeItem(storageKey);
          return null;
        }
        return stored.choice;
      } catch {
        localStorage.removeItem(storageKey);
        return null;
      }
    };

    const saveChoice = (choice) => {
      try {
        localStorage.setItem(
          storageKey,
          JSON.stringify({
            choice,
            expiresAt: now + storageDays * 24 * 60 * 60 * 1000
          })
        );
      } catch {
        return;
      }
    };

    const closeModal = () => {
      saveChoice('us');
      dialog.close();
    };

    const visitLink = dialog.querySelector('[data-international-store-visit]');
    const destination = new URL(dialog.dataset.destination);
    const currentParams = new URLSearchParams(window.location.search);
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((parameter) => {
      if (currentParams.has(parameter)) destination.searchParams.set(parameter, currentParams.get(parameter));
    });
    visitLink.href = destination.toString();

    dialog.querySelector('[data-international-store-close]').addEventListener('click', closeModal);
    dialog.querySelector('[data-international-store-stay]').addEventListener('click', closeModal);
    visitLink.addEventListener('click', () => saveChoice('international'));

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeModal();
    });

    if (forcePreview) {
      dialog.showModal();
      return;
    }

    if (getStoredChoice()) return;

    const endpoint = new URL('browsing_context_suggestions.json', window.location.origin + window.Shopify.routes.root);
    endpoint.searchParams.set('country[enabled]', 'true');
    endpoint.searchParams.set('country[exclude]', 'US');

    fetch(endpoint)
      .then((response) => response.ok ? response.json() : null)
      .then((context) => {
        const country = context?.detected_values?.country?.handle;
        if (country && country !== 'US' && !dialog.open) dialog.showModal();
      })
      .catch(() => {});
  })();
  } catch(e) { console.error(e); }
})();

})();
